(function () {
  'use strict';

  angular.module('tooltip', []);
})();
